import React from 'react';
var DeliveryDocumentLink = function (_a) {
    var language = _a.language, isRoasterUs = _a.isRoasterUs, needJaDeliveryDocument = _a.needJaDeliveryDocument, children = _a.children;
    var googleDocLink = 'https://docs.google.com/spreadsheets/d/102QAYT_8j3LC8GARmOfwZZjJZS_eDHLx/edit#gid=768565240';
    var jaDeliveryDocumentLink = 'http://www.sanyoju.co.jp/Kokyaku/OTHF0090/OTHF00900.aspx';
    var DocumentLinkByLanguage = React.useMemo(function () {
        var links = {
            en: googleDocLink,
            it: googleDocLink,
            es: googleDocLink,
            de: googleDocLink,
            fr: googleDocLink,
        };
        if (needJaDeliveryDocument) {
            links['ja'] = jaDeliveryDocumentLink;
        }
        return links;
    }, [needJaDeliveryDocument]);
    if (!DocumentLinkByLanguage[language])
        return null;
    return isRoasterUs ? (React.createElement("a", { href: "/delivery-document-for-us.pdf", download: "LTL Rates.pdf" }, children)) : (React.createElement("a", { href: DocumentLinkByLanguage[language], target: "_blank", rel: "noopener noreferrer" }, children));
};
export default DeliveryDocumentLink;
